var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Search",
    clipPath: "url(#clip0_15529_146)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconly Two-tone Search"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 739-2",
    d: "M12.2218 23.5029C18.4521 23.5029 23.5027 18.4523 23.5027 12.222C23.5027 5.99179 18.4521 0.941162 12.2218 0.941162C5.99154 0.941162 0.940918 5.99179 0.940918 12.222C0.940918 18.4523 5.99154 23.5029 12.2218 23.5029Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 181-2",
    opacity: 0.4,
    d: "M20.0396 20.9933L24.4565 25.3977",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15529_146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.4228,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterSearch);
export default __webpack_public_path__ + "static/media/footer_search.3ced40dc67323b69c5df16b993d4985a.svg";
export { ForwardRef as ReactComponent };